export const themes = {
  basil: {
    dark: false,
    colors: {
      primary: '#356859',
      secondary: '#FD5523',
      accent: '#37966F',
      tertiary: '#B9E4C9',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FF8F00',
      error: '#B00020',
      background: '#FFFBE6',
      surface: '#FFFBE6',
      'surface-light': '#ECE9D5',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#B9E4C9',
      'on-primary': '#FFFFFF',
      'on-secondary': '#FFFFFF',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#356859',
      'on-surface': '#356859',
      'on-surface-variant': '#356859',
    },
    variables: {
      'body-font-family': '"Montserrat", "Lekton", sans-serif',
      'font-size': 16,
      'border-color': '#356859',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#B9E4C9',
      'theme-on-kbd': '#356859',
      'theme-code': '#F0F8F4',
      'theme-on-code': '#356859',
    },
  },
  basilDark: {
    dark: true,
    colors: {
      primary: '#B9E4C9',
      secondary: '#FF7961',
      accent: '#37966F',
      tertiary: '#356859',
      success: '#81C784',
      info: '#64B5F6',
      warning: '#FFB74D',
      error: '#CF6679',
      background: '#1B2B21',
      surface: '#1B2B21',
      'surface-light': '#2C3E32',
      'surface-bright': '#3A4D3D',
      'surface-variant': '#2C3E32',
      'on-primary': '#1B2B21',
      'on-secondary': '#000000',
      'on-accent': '#FFFFFF',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#000000',
      'on-background': '#B9E4C9',
      'on-surface': '#B9E4C9',
      'on-surface-variant': '#B9E4C9',
    },
    variables: {
      'body-font-family': '"Montserrat", "Lekton", sans-serif',
      'font-size': 16,
      'border-color': '#B9E4C9',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#2C3E32',
      'theme-on-kbd': '#B9E4C9',
      'theme-code': '#2C3E32',
      'theme-on-code': '#B9E4C9',
    },
  },
  crane: {
    dark: false,
    colors: {
      primary: '#5D1049',
      secondary: '#E30425',
      accent: '#4E0D3A',
      tertiary: '#720D5D',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FF9800',
      error: '#E30425',
      background: '#E1BEE7',
      surface: '#FFFFFF',
      'surface-light': '#F8F0F8',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#F3E5F5',
      'on-primary': '#FFFFFF',
      'on-secondary': '#FFFFFF',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#1C1B1F',
      'on-surface': '#1C1B1F',
      'on-surface-variant': '#49454F',
    },
    variables: {
      'body-font-family': 'Raleway, sans-serif',
      'font-size': 16,
      'border-color': '#5D1049',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#F3E5F5',
      'theme-on-kbd': '#5D1049',
      'theme-code': '#F8F0F8',
      'theme-on-code': '#5D1049',
    },
  },
  craneDark: {
    dark: true,
    colors: {
      primary: '#7B1FA2',
      secondary: '#FF5252',
      accent: '#8B4A7C',
      tertiary: '#A64D8A',
      success: '#66BB6A',
      info: '#42A5F5',
      warning: '#FFA726',
      error: '#FF5252',
      background: '#1A0D1B',
      surface: '#2D1B2E',
      'surface-light': '#3A2A3B',
      'surface-bright': '#473447',
      'surface-variant': '#3A2A3B',
      'on-primary': '#000000',
      'on-secondary': '#000000',
      'on-accent': '#000000',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#000000',
      'on-background': '#E8D5E9',
      'on-surface': '#E8D5E9',
      'on-surface-variant': '#D0B8D1',
    },
    variables: {
      'body-font-family': 'Raleway, sans-serif',
      'font-size': 16,
      'border-color': '#7B1FA2',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#3A2A3B',
      'theme-on-kbd': '#E8D5E9',
      'theme-code': '#3A2A3B',
      'theme-on-code': '#E8D5E9',
    },
  },
  fortnightly: {
    dark: false,
    colors: {
      primary: '#6B38FB',
      secondary: '#6B38FB',
      accent: '#FF6B9D',
      tertiary: '#8B5CF6',
      success: '#66BB6A',
      info: '#42A5F5',
      warning: '#FFA726',
      error: '#FF5252',
      background: '#FFFFFF',
      surface: '#FFFFFF',
      'surface-light': '#FFFFFF',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#E8DDFF',
      'on-primary': '#FFFFFF',
      'on-secondary': '#FFFFFF',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#1C1C1E',
      'on-surface': '#1C1C1E',
      'on-surface-variant': '#9E9E9E',
    },
    variables: {
      'body-font-family': '"Libre Franklin", sans-serif',
      'font-size': 16,
      'border-color': '#6B38FB',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#E8DDFF',
      'theme-on-kbd': '#6B38FB',
      'theme-code': '#FEFFFE',
      'theme-on-code': '#6B38FB',
    },
  },
  fortnightlyDark: {
    dark: true,
    colors: {
      primary: '#8B5CF6',
      secondary: '#A78BFA',
      accent: '#F472B6',
      tertiary: '#6B38FB',
      success: '#58D68D',
      info: '#5DADE2',
      warning: '#FFB84D',
      error: '#FF6B6B',
      background: '#0F0F0F',
      surface: '#1A1A1A',
      'surface-light': '#242424',
      'surface-bright': '#404040',
      'surface-variant': '#353535',
      'on-primary': '#FFFFFF',
      'on-secondary': '#FFFFFF',
      'on-accent': '#FFFFFF',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#FFFFFF',
      'on-surface': '#FFFFFF',
      'on-surface-variant': '#6B7280',
    },
    variables: {
      'body-font-family': '"Libre Franklin", sans-serif',
      'font-size': 16,
      'border-color': '#8B5CF6',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#242424',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#242424',
      'theme-on-code': '#FFFFFF',
    },
  },
  owl: {
    dark: false,
    colors: {
      primary: '#FFDE03',
      secondary: '#0336FF',
      accent: '#FF0266',
      tertiary: '#FFE54C',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FF9800',
      error: '#FF5252',
      background: '#FFFFFF',
      surface: '#FFFFFF',
      'surface-light': '#FEFEFE',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#F5F5F5',
      'on-primary': '#000000',
      'on-secondary': '#FFFFFF',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#1A1A1A',
      'on-surface': '#1A1A1A',
      'on-surface-variant': '#9E9E9E',
    },
    variables: {
      'body-font-family': 'Rubik, sans-serif',
      'font-size': 16,
      'border-color': '#FFDE03',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#F5F5F5',
      'theme-on-kbd': '#1A1A1A',
      'theme-code': '#FEFEFE',
      'theme-on-code': '#1A1A1A',
    },
  },
  owlDark: {
    dark: true,
    colors: {
      primary: '#FFE54C',
      secondary: '#FF4D9A',
      accent: '#5C7CFF',
      tertiary: '#FFDE03',
      success: '#81C784',
      info: '#64B5F6',
      warning: '#FFB74D',
      error: '#FF6B6B',
      background: '#0F0F0F',
      surface: '#1A1A1A',
      'surface-light': '#242424',
      'surface-bright': '#404040',
      'surface-variant': '#353535',
      'on-primary': '#000000',
      'on-secondary': '#000000',
      'on-accent': '#000000',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#000000',
      'on-background': '#FFFFFF',
      'on-surface': '#FFFFFF',
      'on-surface-variant': '#6B7280',
    },
    variables: {
      'body-font-family': 'Rubik, sans-serif',
      'font-size': 16,
      'border-color': '#FFE54C',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#242424',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#242424',
      'theme-on-code': '#FFFFFF',
    },
  },
  rally: {
    dark: false,
    colors: {
      primary: '#045D56',
      secondary: '#1EB980',
      accent: '#B15DFF',
      tertiary: '#FF6859',
      quaternary: '#FFCF44',
      quinary: '#72DEFF',
      senary: '#FFD54F',
      success: '#43A047',
      info: '#1E88E5',
      warning: '#FDD835',
      error: '#E53935',
      background: '#FFFFFF',
      surface: '#FFFFFF',
      'surface-light': '#F8F8F8',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#E8F5E8',
      'on-primary': '#FFFFFF',
      'on-secondary': '#000000',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#1C1C1E',
      'on-surface': '#1C1C1E',
      'on-surface-variant': '#2C4A2E',
    },
    variables: {
      'body-font-family': '"Eczar", "Roboto Condensed", sans-serif',
      'font-size': 16,
      'border-color': '#045D56',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#E8F5E8',
      'theme-on-kbd': '#045D56',
      'theme-code': '#F8F8F8',
      'theme-on-code': '#1C1C1E',
    },
  },
  rallyDark: {
    dark: true,
    colors: {
      primary: '#1EB980',
      secondary: '#045D56',
      tertiary: '#FF6859',
      quaternary: '#FFCF44',
      quinary: '#B15DFF',
      senary: '#72DEFF',
      accent: '#FFD54F',
      success: '#66BB6A',
      info: '#42A5F5',
      warning: '#FFEB3B',
      error: '#EF5350',
      background: '#33333d',
      surface: '#33333d',
      'surface-light': '#373740',
      'surface-bright': '#40404a',
      'surface-variant': '#3a3a44',
      'on-primary': '#000000',
      'on-secondary': '#FFFFFF',
      'on-accent': '#000000',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#000000',
      'on-background': '#FFFFFF',
      'on-surface': '#FFFFFF',
      'on-surface-variant': '#CCCCCC',
    },
    variables: {
      'body-font-family': '"Eczar", "Roboto Condensed", sans-serif',
      'font-size': 16,
      'border-color': '#33333d',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#40404a',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#40404a',
      'theme-on-code': '#FFFFFF',
    },
  },
  reply: {
    dark: false,
    colors: {
      primary: '#344955',
      secondary: '#F9AA33',
      accent: '#4A6572',
      tertiary: '#607D8B',
      success: '#2E7D32',
      info: '#344955',
      warning: '#F9AA33',
      error: '#C62828',
      background: '#FFFFFF',
      surface: '#FFFFFF',
      'surface-light': '#FAFAFA',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#F5F5F5',
      'on-primary': '#FFFFFF',
      'on-secondary': '#000000',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#232F34',
      'on-surface': '#232F34',
      'on-surface-variant': '#757575',
    },
    variables: {
      'body-font-family': 'Work Sans, sans-serif',
      'font-size': 16,
      'border-color': '#344955',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#F5F5F5',
      'theme-on-kbd': '#344955',
      'theme-code': '#FAFAFA',
      'theme-on-code': '#232F34',
    },
  },
  replyDark: {
    dark: true,
    colors: {
      primary: '#4A6572',
      secondary: '#FFB74D',
      accent: '#607D8B',
      tertiary: '#344955',
      success: '#66BB6A',
      info: '#42A5F5',
      warning: '#FFB74D',
      error: '#EF5350',
      background: '#121212',
      surface: '#1E1E1E',
      'surface-light': '#2C2C2C',
      'surface-bright': '#383838',
      'surface-variant': '#424242',
      'on-primary': '#FFFFFF',
      'on-secondary': '#000000',
      'on-accent': '#FFFFFF',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#000000',
      'on-background': '#FFFFFF',
      'on-surface': '#FFFFFF',
      'on-surface-variant': '#AAAAAA',
    },
    variables: {
      'body-font-family': 'Work Sans, sans-serif',
      'font-size': 16,
      'border-color': '#4A6572',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#2C2C2C',
      'theme-on-kbd': '#FFFFFF',
      'theme-code': '#2C2C2C',
      'theme-on-code': '#FFFFFF',
    },
  },
  shrine: {
    dark: false,
    colors: {
      primary: '#F4A79D',
      secondary: '#FEEAE6',
      accent: '#442C2E',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FB8C00',
      error: '#B3261E',
      background: '#FFEEE9',
      surface: '#FFFBF7',
      'surface-light': '#FEDBD0',
      'surface-bright': '#FFFFFF',
      'surface-variant': '#F7E7E1',
      'on-primary': '#442C2E',
      'on-secondary': '#442C2E',
      'on-accent': '#FFFFFF',
      'on-success': '#FFFFFF',
      'on-info': '#FFFFFF',
      'on-warning': '#000000',
      'on-error': '#FFFFFF',
      'on-background': '#442C2E',
      'on-surface': '#442C2E',
      'on-surface-variant': '#5D4037',
    },
    variables: {
      'body-font-family': 'Rubik, sans-serif',
      'font-size': 16,
      'border-color': '#442C2E',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#F7E7E1',
      'theme-on-kbd': '#442C2E',
      'theme-code': '#FFFBF7',
      'theme-on-code': '#442C2E',
    },
  },
  shrineDark: {
    dark: true,
    colors: {
      primary: '#F4A79D',
      secondary: '#E57C73',
      accent: '#FEDBD0',
      tertiary: '#8D6E63',
      success: '#66BB6A',
      info: '#42A5F5',
      warning: '#FFB74D',
      error: '#F28B82',
      background: '#2C1B18',
      surface: '#3E2723',
      'surface-light': '#4E342E',
      'surface-bright': '#5D4037',
      'surface-variant': '#4E342E',
      'on-primary': '#2C1B18',
      'on-secondary': '#2C1B18',
      'on-accent': '#442C2E',
      'on-success': '#000000',
      'on-info': '#000000',
      'on-warning': '#000000',
      'on-error': '#2C1B18',
      'on-background': '#F5E6E0',
      'on-surface': '#F5E6E0',
      'on-surface-variant': '#D7C0B8',
    },
    variables: {
      'body-font-family': 'Rubik, sans-serif',
      'font-size': 16,
      'border-color': '#F4A79D',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.6,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': '#4E342E',
      'theme-on-kbd': '#F5E6E0',
      'theme-code': '#3E2723',
      'theme-on-code': '#F5E6E0',
    },
  },
};
